import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    orgUnit: {},
    loaded: false,
    orgUnitId: 0,
    updateMessage: "",
    changeType: ""
  }
};
const orgUnitItemSlice = createSlice({
  name: "orgUnitItem",
  initialState,
  reducers: {
    loadOneOrgUnit: (state, action) => {
      if (action.payload.message === "Success") {
        state.value = {
          orgUnit: action.payload.item,
          loaded: true,
          orgUnitId: action.payload.item.orgUnitId,
          updateMessage: "success",
          changeType: "load"
        };
      } else {
        state.value = {
          orgUnit: {},
          loaded: false,
          orgUnitId: 0,
          updateMessage: "",
          changeType: ""
        };
      }
    },
    clearOrgUnit: (state) => {
      state.value = {
        orgUnit: { orgUnitId: 0, name: "" },
        loaded: false,
        orgUnitId: 0,
        updateMessage: "",
        changeType: ""
      };
    },
    updateOrgUnit: (state, action) => {
      if (action.payload.message === "success") {
        state.value = {
          orgUnit: action.payload.item,
          loaded: true,
          orgUnitId: action.payload.item.orgUnitId,
          updateMessage: "success",
          changeType: "update"
        };
      } else {
        state.value = {
          orgUnit: action.payload.item,
          loaded: true,
          orgUnitId: action.payload.item.orgUnitId,
          updateMessage: action.payload.message,
          changeType: "update"
        };
      }
    }
  }
});
export const { loadOneOrgUnit, updateOrgUnit, clearOrgUnit } = orgUnitItemSlice.actions;
export default orgUnitItemSlice.reducer;
